import { DocsTabItem } from '../types';

export const DOCS_TABS: DocsTabItem[] = [
  { id: 'home', label: 'HOME' },
  { id: 'getting-started', label: 'GETTING STARTED' },
  { id: 'landing-page-guide', label: 'LANDING PAGE GUIDE' },
  { id: 'service-management-api', label: 'SERVICE MANAGEMENT API' },
  { id: 'help', label: 'HELP' },
  { id: 'release-notes', label: 'RELEASE NOTES' },
];
